module.exports = __webpack_public_path__ + "../resources/images/illustration_balloon-de2fcab1e569ee7affc785e5c80aa5c4.svg";